import { Component, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IsIgxDialogComponent, IsIgxHubComponent, IsIgxMappingComponent } from '@interserve/igx-angular'
import { IgxButtonModule } from '@infragistics/igniteui-angular'
import { AreaMappingHubData, SimulationMappingData, SimulationStaticLeftWbs, SimulationStaticRightWbs, selectDataHub } from '../test/data'
import { environment } from 'src/environments/environment'
@Component({
    selector: 'is-igx-wbs-sample',
    standalone: true,
    templateUrl: './is-igx-wbs-sample.component.html',
    styleUrl: './is-igx-wbs-sample.component.scss',
    imports: [
        CommonModule,
        FormsModule,
        IsIgxMappingComponent,
        IsIgxHubComponent,
        IsIgxDialogComponent,
        IgxButtonModule,
    ],
})
export class SampleTestDataSelectComponent {
    @ViewChild('selectDataHub', { static: true }) public selectDataHub: IsIgxHubComponent | undefined
    constructor() {}
    loading = true
    environmentKey = environment.environmentKey
    StaticLeftWbsData: any = undefined
    StaticRightWbsData: any = undefined
    basePathInfo: any = undefined
    mappingData: any = undefined
    mappingDataString = ''
    //HUB設定（紐づけで使用）
    mappingDataHub: any = AreaMappingHubData
    staticSelectTestData = structuredClone(selectDataHub)
    selectedTestDataIds: any[] = []

    ngOnInit(): void {
        //物流改善
        this.mappingData = SimulationMappingData
        this.StaticLeftWbsData = SimulationStaticLeftWbs
        this.StaticRightWbsData = SimulationStaticRightWbs

        this.mappingDataString = JSON.stringify(this.mappingData, null, 2)
        this.loading = false
    }

    reflectMappingData() {
        try {
            const json = JSON.parse(this.mappingDataString)
            this.mappingData = json
        } catch (error) {
            console.error(error)
        }
    }
}
